import { config } from '../utils/config';

export const msalConfig = {
  auth: {
    clientId: config.azure.clientId || "",
    authority: config.azure.authorityUrl || "",
    redirectUri: config.azure.redirectUri || "",
  },
  scopes: ["openid", "profile", config.azure.scope],
};

export const loginRequest = {
  scopes: ["openid", "profile", config.azure.scope],
};

export const logoutRequest = {
  postLogoutRedirectUri: config.azure.redirectUri,
};
